import { useEffect, useState } from 'react'; // добавлен useState
import styles from './PaymentComponent.module.css';
import { useAppConfig } from '../../context/AppConfigContext';
import { fetchData } from '../../api/api';
import ShowVip from '../ShowVip';
import { handleError } from '../../context/errors/errorUtils';

const GooglePlayPaymentComponent = ({ tariff, tariffConfig, onClose }) => {
  const { t, userInfo, baseLanguage, updateConfig } = useAppConfig();
  const [showVip, setShowVip] = useState(false);
  const [isPurchaseStarted, setIsPurchaseStarted] = useState(false);

  useEffect(() => {
    const handleSuccess = async (event) => {
      const { purchaseToken } = event.detail;

      try {
        const response = await fetchData('/api/google-play/confirm', 'POST', {
          userId: userInfo.userId,
          purchaseToken,
		  tariffId: tariff,
        });

        if (!response.success) {
          throw new Error(`Payment confirmation failed: ${response.error || 'Unknown error'}`);
        }
        
        setShowVip(true); // показываем VIP компонент
		  updateConfig({
			userInfo: { ...userInfo, showVip: true },
		  });		
        onClose(); // закрываем текущий модал/экран покупки
      } catch (error) {
        handleError({
          code: 'ERROR_PAYMENT_CONFIRMATION',
          error,
          context: { module: 'GooglePlayPaymentComponent', tariff, tariffConfig, userId: userInfo.userId },
          showToUser: true,
        });
        //alert(`Ошибка подтверждения покупки: ${error.message}`);
      }
    };

    const handleErrorEvent = (event) => {
      alert(`${t.payment.google_play_error || 'Ошибка при оплате через Google Play.'}\nПодробности: ${event.detail.message}`);
      onClose();
    };

    // обработчик отмены покупки
    const handleCancelEvent = () => {  
      onClose(); // Просто закрываем экран обработки без показа ошибки
    };

    // подписываемся на события
    window.addEventListener("purchaseSuccess", handleSuccess);
    window.addEventListener("purchaseError", handleErrorEvent);
    window.addEventListener("purchaseCanceled", handleCancelEvent); // ДОБАВЛЕНО

	if (isPurchaseStarted) return; // защита от повторного вызова
	setIsPurchaseStarted(true);

    // запускаем покупку. старый вариант с обычными подписками, новый вариант с вечной покупкой. 
	if (window.Android) {
	  if (tariffConfig.type === 'lifetime') {
		window.Android.buyLifetime(tariffConfig.googlename);
	  } else {
		window.Android.buyPremium(tariffConfig.googlename);
	  }
	} else {
	  alert("Android billing API not available");
	  onClose();
	}	

    // отписка при размонтировании
    return () => {
      window.removeEventListener("purchaseSuccess", handleSuccess);
      window.removeEventListener("purchaseError", handleErrorEvent);
      window.removeEventListener("purchaseCanceled", handleCancelEvent); // ДОБАВЛЕНО
    };
  }, []);
  //}, [tariff, tariffConfig, onClose, t, userInfo.userId]);

  return (
    <>
      {showVip && <ShowVip language={baseLanguage} onClose={onClose} />}
      <div className={styles.processing}>
        <p>{t.payment.processing || 'Обработка покупки...'}</p>
      </div>
    </>
  );
};

export default GooglePlayPaymentComponent;